import { RenderImageValue } from '../../../Image';
import { AnotherUpload } from '../../../../../AnotherUpload';
import {
  TYPE_FILE,
  TYPE_FILE_UPLOAD_CLAIM,
} from '../../../../../AnotherUpload/controller/constants';
import {
  DropFieldAction,
  DropFieldActions,
  LoaderContainer,
} from '../../../../styles';
import { Default } from '../../../Default';
import { Drop } from '../../../Drop';
import { useImageCaptureFieldController } from './controller';
import { Icon } from '../../../../../Icon';
import { ImageFieldViewProps } from '../../../Image/types';
import { TypeMediaField } from '../../../../types';
import { ImageCaptureInputViewProps } from './types';

function RenderField({
  value,
  onChange,
  anotherUpload,
  liveOnly,
  handlerButtonClick,
  RenderValueComponent,
  anotherType,
  anotherCommentType,
  textOptions,
}: ImageCaptureInputViewProps) {
  return anotherUpload ? (
    <AnotherUpload
      label={textOptions.anotherLabel}
      onChange={onChange}
      type={anotherType}
      typeUploads={[anotherUpload]}
      commentType={anotherCommentType}
    />
  ) : value ? (
    <RenderValueComponent value={value} />
  ) : (
    <Default
      handlerButtonClick={handlerButtonClick}
      liveOnly={liveOnly}
      textOptions={textOptions}
    />
  );
}

export function ImageCaptureField({
  onChange,
  value,
  error,
  options,
  loading,
  needRefresh,
  typeUploads,
}: ImageFieldViewProps) {
  const {
    toggleAnotherUpload,
    isAnotherQR,
    isAnotherEmail,
    handlerRemove,
    handlerButtonClick,
    anotherUpload,
    inputProps,
    handlerChange,
    handlerCapture,
    captureRef,
    liveOnly,
    dropFieldProps,
    inputFile,
    handlerUpload,
    textOptions,
  } = useImageCaptureFieldController({
    options,
    onChange,
    needRefresh,
    typeUploads,
  });

  if (value) {
    return <RenderImageValue value={value} handleRemove={handlerRemove} />;
  }

  return (
    <Drop
      {...dropFieldProps}
      liveOnly={!!liveOnly}
      rejected={dropFieldProps.rejected}
      errorType={TypeMediaField.IMAGE}
      error={error}
    >
      {loading && (
        <LoaderContainer>
          <div>
            <Icon glyph="spinner" />
          </div>
        </LoaderContainer>
      )}
      <>
        <input
          {...inputProps}
          accept="image/*"
          type="file"
          ref={inputFile}
          onChange={handlerChange}
          style={{ display: 'none' }}
          multiple={false}
        />
        <input
          accept="image/*"
          type="file"
          ref={captureRef}
          onChange={handlerChange}
          style={{ display: 'none' }}
          multiple={false}
          capture="user"
        />
        <RenderField
          onChange={handlerUpload}
          anotherUpload={anotherUpload}
          value={value}
          liveOnly={!!liveOnly}
          handlerButtonClick={handlerButtonClick}
          anotherType={TYPE_FILE.IMG}
          anotherCommentType="image"
          RenderValueComponent={RenderImageValue}
          textOptions={textOptions}
        />
      </>
      <DropFieldActions>
        <div>
          {!value && !anotherUpload && (
            <DropFieldAction onClick={handlerCapture}>
              <Icon glyph="webCamera" />
            </DropFieldAction>
          )}
        </div>
        <div>
          {value && (
            <DropFieldAction onClick={handlerRemove}>
              <Icon glyph="delete" />
            </DropFieldAction>
          )}
          {anotherUpload && (
            <DropFieldAction onClick={toggleAnotherUpload()}>
              <Icon glyph="cross" />
            </DropFieldAction>
          )}
          {!anotherUpload && !value && isAnotherEmail && (
            <DropFieldAction
              onClick={toggleAnotherUpload(TYPE_FILE_UPLOAD_CLAIM.EMAIL)}
            >
              <Icon glyph="mail" />
            </DropFieldAction>
          )}
          {!anotherUpload && !value && isAnotherQR && (
            <DropFieldAction
              onClick={toggleAnotherUpload(TYPE_FILE_UPLOAD_CLAIM.QR)}
            >
              <Icon glyph="devices" />
            </DropFieldAction>
          )}
        </div>
      </DropFieldActions>
    </Drop>
  );
}
